"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgSymphony = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_SYMPHONY", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M4 11.313c0 .355.189.683.496.862l3.004 1.75 3.004-1.75a.998.998 0 0 0 .496-.862V9.505L2 7.009V2.53c0-.656.338-1.366 1.062-1.691C3.836.492 5.318 0 7.5 0s3.664.492 4.438.84C12.662 1.165 13 1.875 13 2.53v2.516l-2-.554V2.61c-.587-.247-1.752-.613-3.5-.613s-2.913.366-3.5.613V5.49L13 8v3.313c0 1.065-.567 2.05-1.488 2.587l-3.256 1.896a1.502 1.502 0 0 1-1.512 0L3.488 13.9A2.994 2.994 0 0 1 2 11.313V9.485L4 10v1.313Z" }))); };
exports.default = SvgSymphony;
